import { relativo } from "@gestiondoc/shared";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { queryClient, useTRPC } from "../api.ts";
import { Encabezado } from "../componentes/Encabezado.tsx";
import { Boton, EstadoVacio } from "../componentes/ui.tsx";

/** La campana: lo que el sistema le avisó a esta persona. Abrir un aviso lo marca como leído. */
export function PaginaAvisos() {
  const trpc = useTRPC();
  const navigate = useNavigate();
  const avisos = useQuery(trpc.notificaciones.listar.queryOptions());
  const marcar = useMutation(
    trpc.notificaciones.marcarLeidas.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: trpc.notificaciones.listar.queryKey() });
        queryClient.invalidateQueries({ queryKey: trpc.yo.perfil.queryKey() });
      },
    }),
  );

  async function abrir(aviso: { id: string; enlace: string; leida: boolean }) {
    if (!aviso.leida) await marcar.mutateAsync({ id: aviso.id });
    // El enlace lo escribe el servidor y es siempre una ruta de la app; si alguna vez no lo
    // fuera, no se sale de GestionDOC.
    const interno = aviso.enlace.startsWith("/") && !aviso.enlace.startsWith("//");
    navigate({ to: interno ? aviso.enlace : "/avisos" });
  }

  return (
    <div>
      <Encabezado
        overline="Sistema"
        titulo="Avisos"
        acciones={
          !!avisos.data?.sinLeer && (
            <Boton variante="secundario" onClick={() => marcar.mutate({})}>
              Marcar todos como leídos
            </Boton>
          )
        }
      />
      {avisos.isPending && <EstadoVacio>Cargando…</EstadoVacio>}
      {avisos.data && avisos.data.notificaciones.length === 0 && (
        <EstadoVacio>Todavía no tienes avisos.</EstadoVacio>
      )}
      {avisos.data && avisos.data.notificaciones.length > 0 && (
        <ul className="divide-y divide-borde/60 rounded-tarjeta border border-borde bg-white">
          {avisos.data.notificaciones.map((a) => (
            <li key={a.id}>
              <button
                type="button"
                onClick={() => abrir(a)}
                className="flex w-full items-start gap-3 px-4 py-3 text-left hover:bg-fondo"
              >
                <span
                  className={`mt-1.5 size-2 shrink-0 rounded-full ${a.leida ? "bg-transparent" : "bg-rojo-marca"}`}
                />
                <span className="min-w-0 flex-1">
                  <span
                    className={`block ${a.leida ? "text-texto-2" : "font-semibold text-marino"}`}
                  >
                    {a.titulo}
                  </span>
                  {a.cuerpo && <span className="block text-[12px] text-texto-3">{a.cuerpo}</span>}
                </span>
                <span className="shrink-0 text-[11.5px] text-texto-3">{relativo(a.creadaEn)}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
